import React from "react";
import { Box } from "@mui/material";
import Sidebar from "./Sidebar";
import Header from "./Header";
import Footer from "./Footer";

const Layout = ({ children, currentUser }) => {
  const isAdmin = currentUser?.role === 1;

  return (
    <Box sx={{ display: "flex", flexDirection: "column", height: "100vh" }}>
      <Header currentUser={currentUser} />
      {currentUser ? (
        <Box sx={{ display: "flex", flexGrow: 1, flexDirection: "column" }}>
          <Box sx={{ display: "flex", flexGrow: 1 }}>
            <Sidebar currentUser={currentUser} isAdmin={isAdmin} />
            <Box sx={{ flexGrow: 1, p: 2, overflow: "auto" }}>{children}</Box>
          </Box>
          <Footer /> {/* Add Footer here */}
        </Box>
      ) : (
        <Box
          sx={{
            flexGrow: 1,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {children}
          <Footer /> {/* Add Footer here */}
        </Box>
      )}
    </Box>
  );
};

export default Layout;
